module.exports = __webpack_public_path__ + "static/media/price-img3.93e8a2ed.webp";